/** @jsxImportSource @emotion/react */

import type { Interpolation } from "@emotion/react";
import { I18nMessage } from "@i18n/react";
import type { HTMLAttributes } from "react";

import { StarIcon, Text } from "../../../emotion";
import type { ThemeType } from "../../../global/emotion";

const STAR_COUNT = 5;

type ReviewsProps = Omit<HTMLAttributes<HTMLDivElement>, "children">;

const cssReview: Interpolation<ThemeType> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing.xxs,
});
const cssReviewsContainer: Interpolation<ThemeType> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing.xl,
});
const cssReviewStarsContainer: Interpolation = {
  display: "flex",
  gap: 1,
};

const REVIEWS = [
  {
    description: "subscription_testimonial_text_1",
    title: "subscription_testimonial_title_1",
  },
  {
    description: "subscription_testimonial_text_2",
    title: "subscription_testimonial_title_2",
  },
  {
    description: "subscription_testimonial_text_3",
    title: "subscription_testimonial_title_3",
  },
  {
    description: "subscription_testimonial_text_4",
    title: "subscription_testimonial_title_4",
  },
  {
    description: "subscription_testimonial_text_5",
    title: "subscription_testimonial_title_5",
  },
  {
    description: "subscription_testimonial_text_6",
    title: "subscription_testimonial_title_6",
  },
];

export const Reviews = ({ className, ...props }: ReviewsProps) => (
  <div className={className} css={cssReviewsContainer} {...props}>
    {REVIEWS.map((review) => (
      <div css={cssReview} key={review.title}>
        <div css={cssReviewStarsContainer}>
          {Array.from({ length: STAR_COUNT }, (_, index) => (
            <StarIcon.Filled
              color="rgba(156,75,227,1.00)"
              key={index}
              size={14}
            />
          ))}
        </div>
        <Text as="span" size="m" type="title">
          <I18nMessage message={review.title} />
        </Text>
        <Text as="span" size="xl" type="detail">
          <I18nMessage message={review.description} />
        </Text>
      </div>
    ))}
  </div>
);
